import { BGSlot, BGSlot_Thumb } from "../../../../../assets";
import { IMiniGameProps } from "../../../../../../typings/common";
import BonusGameCard from "./BonusGameCard";

function BGSlotGame({
  isSmall,
  onStartGame,
  config,
  miniGameData,
  playerLevel,
}: IMiniGameProps) {
  return (
    <BonusGameCard
      isSmall={isSmall}
      onStartGame={onStartGame}
      config={config}
      miniGameData={miniGameData}
      playerLevel={playerLevel}
      titleSource={BGSlot}
      thumbSource={BGSlot_Thumb}
      launchPath="/slot/bowaPlayer.html"
      cooldownHours={12}
      freePlayTitleFontSize={13}
      infoPaddingVertical={4}
      hideDividerOnSmall
    />
  );
}

export default BGSlotGame;
